import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    create: { type: Boolean, default: false },
    suggestionsUrl: String,
    maxItems: Number,
    placeholder: String
  }

  connect() {
    const options = {}
    if (this.hasCreateValue) options.create = this.createValue
    if (this.hasMaxItemsValue) options.maxItems = this.maxItemsValue
    if (this.hasPlaceholderValue) options.placeholder = this.placeholderValue

    // Use main as dropdown parent to account for nested scrolling; fallback to body
    this.dropdownParent = document.querySelector('main') || document.body
    options.dropdownParent = this.dropdownParent
    options.openOnFocus = true
    options.createOnBlur = true
    options.persist = true

    this.select = new TomSelect(this.element, options)

    // Position dropdown using fixed coords so it isn't clipped or misplaced when main scrolls
    this.reposition = () => {
      if (!this.select?.dropdown || !this.select?.control) return
      const rect = this.select.control.getBoundingClientRect()
      const dp = this.select.dropdown
      dp.style.position = 'fixed'
      dp.style.left = `${rect.left}px`
      dp.style.top = `${rect.bottom}px`
      dp.style.width = `${rect.width}px`
    }

    // Ensure dropdown opens and is positioned
    this.select.on('focus', () => { this.reposition(); this.select.open() })
    this.select.on('dropdown_open', () => { this.reposition() })
    this.select.on('type', () => { this.reposition() })

    // Reposition on scroll/resize
    this.scrollContainer = this.dropdownParent === document.body ? window : this.dropdownParent
    this.boundReposition = () => this.reposition()
    window.addEventListener('resize', this.boundReposition)
    this.scrollContainer.addEventListener('scroll', this.boundReposition, { passive: true })

    // On blur, commit free-typed value so it doesn't clear
    this.select.on('blur', () => {
      const v = (this.select.input?.value || '').trim()
      if (!v) return
      if (!this.select.options[v]) this.select.addOption({ value: v, text: v })
      this.select.setValue(v, true)
    })

    if (this.hasSuggestionsUrlValue) {
      fetch(this.suggestionsUrlValue)
        .then(r => r.json())
        .then(data => {
          const suggestions = (data.suggestions || []).map(l => ({ value: l, text: l }))
          this.select.addOptions(suggestions)
          this.select.refreshOptions(false)
        })
        .catch(() => {})
    }
  }

  disconnect() {
    try { window.removeEventListener('resize', this.boundReposition) } catch(e) {}
    try { (this.scrollContainer || window).removeEventListener('scroll', this.boundReposition) } catch(e) {}
    this.select && this.select.destroy()
  }
}
